var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("footer", [
      _c("ul", [
        _c("li", { on: { click: _vm.home } }, [
          _vm.$route.path === "/home"
            ? _c("img", {
                staticClass: "home",
                attrs: {
                  src: require("@/assets/footer/アセット 14@2x.png"),
                  width: "295",
                  height: "319",
                  loding: "lazy"
                }
              })
            : _c("img", {
                staticClass: "home",
                attrs: {
                  src: require("@/assets/footer/アセット 17@2x.png"),
                  width: "295",
                  height: "319",
                  loding: "lazy"
                }
              })
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.mealHistory } }, [
          _vm.$route.path === "/history"
            ? _c("img", {
                staticClass: "meal-history",
                attrs: {
                  src: require("@/assets/footer/アセット 15@2x.png"),
                  width: "360",
                  height: "306",
                  loding: "lazy"
                }
              })
            : _c("img", {
                staticClass: "meal-history",
                attrs: {
                  src: require("@/assets/footer/アセット 18@2x.png"),
                  width: "360",
                  height: "306",
                  loding: "lazy"
                }
              })
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.other } }, [
          _vm.$route.path === "/other"
            ? _c("img", {
                staticClass: "other",
                attrs: {
                  src: require("@/assets/footer/アセット 16@2x.png"),
                  width: "271",
                  height: "243",
                  loding: "lazy"
                }
              })
            : _c("img", {
                staticClass: "other",
                attrs: {
                  src: require("@/assets/footer/アセット 19@2x.png"),
                  width: "271",
                  height: "243",
                  loding: "lazy"
                }
              })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 